import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where
} from "firebase/firestore";
import { db } from "../utils/firebase-config";
import type { NewTask, Task } from "../types/models";

export function writeTask(task: NewTask) {
  return addDoc(collection(db, "tasks"), {
    uid: task.uid,
    taskName: task.taskName,
    isCompleted: false,
    createdDate: task.createdDate
  });
}

export function getTasksForUser(uid: string) {
  return getDocs(query(collection(db, "tasks"), where("uid", "==", uid)));
}

export function updateTaskCompletion(taskId: string, isCompleted: boolean) {
  return updateDoc(doc(db, "tasks", taskId), { isCompleted }).then(
    () => undefined
  );
}

export function updateTaskNameForTask(taskId: string, taskName: string) {
  return updateDoc(doc(db, "tasks", taskId), { taskName }).then(
    () => undefined
  );
}

export function updateArchiveStatusForTask(
  taskId: string,
  isArchived: boolean
) {
  return updateDoc(doc(db, "tasks", taskId), { isArchived }).then(
    () => undefined
  );
}
